// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p3-5";
export var filledCircle = "_p3-4";
export var historyEntry = "_p3-3";
export var messageSideLeft = "_p3-1";
export var messageSideRight = "_p3-2";
export var orderTrackingCarouselWrapper = "_p3-6";
export var orderTrackingInfoContainer = "_p3-0";